import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './../style.css'
export default class DashOptionContainer extends Component {
    handleDownloadInfo = () => {
        console.log("ejecute la desscarga")
        this.props.DownloadInfo();
    }
    render() {
        return (
            <Grid className="options">
                <Grid className="Buttons" >
                    <button onClick={this.handleDownloadInfo} className="ButtonReset" >
                        Descargar Resultados
                    </button>
                    {/* <button onClick={this.handleResetFilter} className="ButtonReset" >
                        Volver al estado inicial
                    </button> */}
                </Grid>
            </Grid>
        )
    }
}
